import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-carrousel-sign-image',
  templateUrl: './carrousel-sign-image.component.html',
  styleUrls: ['./carrousel-sign-image.component.css']
})
export class CarrouselSignImageComponent implements OnInit {

  @Input() imagesFiles: Array<any>;
  @Input() maxHeight: any;

  constructor() { }

  currentIndex = 0;

  ngOnInit() {
  }

  moveSlide(move) {
    if (this.currentIndex == 0 && move == -1) this.currentIndex = this.imagesFiles.length - 1;
    else if (this.currentIndex == (this.imagesFiles.length - 1) && move == 1) this.currentIndex = 0;
    else this.currentIndex += move;
  }

  switchSlide(index) {
    this.currentIndex = index;
  }

  setIndexItems() {
    const totalItems = this.imagesFiles.length;

    // Se a lista tiver 11 ou menos itens, retorna todos os índices
    if (totalItems <= 11) {
      return Array.from({ length: totalItems }, (_, i) => i);
    }

    // Calcula os limites inferior e superior para o intervalo de índices
    const start = Math.max(0, this.currentIndex - 5);
    const end = Math.min(totalItems - 1, this.currentIndex + 5);

    // Garante que a lista tenha sempre 11 índices
    let indices = [];
    for (let i = start; i <= end; i++) {
      indices.push(i);
    }

    // Se a lista de índices tiver menos de 11 elementos, adiciona mais índices no início ou fim
    while (indices.length < 11) {
      if (indices[0] > 0) {
        indices.unshift(indices[0] - 1); // Adiciona no início
      } else if (indices[indices.length - 1] < totalItems - 1) {
        indices.push(indices[indices.length - 1] + 1); // Adiciona no fim
      } else {
        break; // Não há mais o que adicionar
      }
    }

    return indices;
  }
}
